// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactDetails_container__hNYeE","details":"ContactDetails_details__qIPB0","noStyle":"ContactDetails_noStyle__5y02X"};